import createActions from 'utils/redux/createActions'

export default createActions([
	'DATA_DOWNLOAD_OK'
  , 'DATA_SAVE_OK'
  , 'DATA_UPDATE_OK'
  , 'DATA_LOAD_OK'
  , 'DATA_INDEX'
  , 'DOC_EXTERNAL_UPDATE'
  , 'DOC_UPDATE'
  , 'DOC_DELETE'
  , 'ADD'
  , 'COMMIT'
  , 'OK'
  , 'CLOSE'
  , 'CLOSE_YES'
  , 'CLOSE_NO'
  , 'ROLLBACK'
  , 'DELETE'
  , 'DELETE_YES'
  , 'DELETE_NO'
  , 'STAGE'
  , 'CLOSE_PROMPT'
  , 'PAID'
  , 'EDIT'
  , 'NEW'
  , 'CANCEL_NAVIGATION'
  , 'DISCARD_AND_NAVIGATE'
  , 'NEW_PROJECT'
  , 'NEW_PAYMENT'
  , 'NEW_APPLICATION'
  , 'LINE_ADD'
])



// WEBPACK FOOTER //
// ./src/actions/dataActions.js